import { Router } from "@angular/router";
import { OktaAuth } from "@okta/okta-auth-js";
import { AppRoutePaths, AppRoutes } from "./shared/common/app-path.routes";
import { inject } from "@angular/core";
export function appInitializer(oktaAuth: OktaAuth) {
  const router = inject(Router);
  return async () => {
    const urlParams = new URLSearchParams(window.location.search);

    // if (window.location.pathname.includes(AppRoutes.InternalUserRegistration)) {
    //   return;
    // }

    if (urlParams.has("code") && urlParams.has("state")) {
      const tokens = await oktaAuth.token.parseFromUrl();
      oktaAuth.tokenManager.setTokens(tokens.tokens);
      return;
    } else if (urlParams.has("error")) {
      // router.navigateByUrl("/login/oktaauthfail");
      return;
    } else if (urlParams.has("code") && urlParams.has("state")) {
      const tokens = await oktaAuth.token.parseFromUrl();
      oktaAuth.tokenManager.setTokens(tokens.tokens);
      return;
    } else {
      const isAuthenticated = await oktaAuth.isAuthenticated();
      if (!isAuthenticated) {
        try {
          await oktaAuth.signInWithRedirect();
        } catch (error) {
          console.error("Authentication failed", error);
          router.navigate([AppRoutePaths[AppRoutes.Login]]);
          return;
        }
      } else {
        return;
      }
    }

    return;
  };
}
